export const createSearchCache = <T>(data: T[], keyField: keyof T) => {
  const map = new Map()
  const cache = new Map()

  for (const item of data) {
    map.set(item[keyField], item)
  }

  return {
    find: <TKey>(key: TKey): T => {
      if (cache.has(key)) {
        return cache.get(key)
      }
      const result = map.get(key)
      cache.set(key, result)

      return result
    },
    clearCache: () => cache.clear(),
  }
}
